import { render, staticRenderFns } from "./SignUpOrganizationWizard.vue?vue&type=template&id=0ad80d04"
import script from "./SignUpOrganizationWizard.vue?vue&type=script&lang=js"
export * from "./SignUpOrganizationWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports